module.exports = __webpack_public_path__ + "assets/img/report-data-bg-4.702bd06b.png";